import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getSessionExpiry } from '@/hooks/LitSessionContext/useLitSession';
import { useSession } from '@/contexts/LitSessionProvider';
import Seo from '@/components/shared/Seo';
import ProfileDataMenu from '@/components/userSettings/profileDataMenu';
import SocialData from '@/components/userSettings/socialData';
import Referral from '@/components/userSettings/Referral';
import LogoutBtn from '@/components/userSettings/LogoutBtn';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import { useUserCloudQuery } from '@/hooks/onboarding/useReferralQuery';
export default function Profilepage() {
  const {
    litSession
  } = useSession();
  const {
    data: userCloudData
  } = useUserCloudQuery();
  const router = useRouter();
  const [isClient, setIsClient] = useState(false);
  const pfp = userCloudData?.data?.pfp ? '/static/genie/' + userCloudData?.data?.pfp : '/static/genie/ava1.png';
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient) {
    return;
  }
  return <div className='bg-genius-indigo' data-sentry-component="Profilepage" data-sentry-source-file="index.tsx">
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <div className='flex flex-col lg:flex-row'>
          <div className='grid'>
            {router.pathname === '/settings' && <Seo title='Settings • Genius Terminal • Trade Crypto Like a Genius' />}

            <div className='pl-4 mt-4 mb-2'>
              <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="index.tsx" />
            </div>
            <ProfileDataMenu pfp={pfp} data-sentry-element="ProfileDataMenu" data-sentry-source-file="index.tsx" />
            <Referral data-sentry-element="Referral" data-sentry-source-file="index.tsx" />
          </div>
        </div>
        <div className='w-full justify-center pb-[160px]'>
          <SocialData data-sentry-element="SocialData" data-sentry-source-file="index.tsx" />
          <div className='my-6 flex-col text-genius-cream/50 flex items-center justify-center text-center'>
            {/* add hour and min in am pm format */}
            <span className='text-[10px] tracking-widest font-light'>Session Active Until: </span>
            <div className='flex gap-1 text[12px]'>
              <p>
                {getSessionExpiry(litSession)?.toLocaleTimeString('en-us', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              })}
                ,
              </p>
              <p>
                {getSessionExpiry(litSession)?.toLocaleDateString('en-us', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </p>
            </div>
          </div>
          <div className='z-50 fixed bottom-[70px] flex gap-2 w-full px-2 pb-[10px]'>
            {/* Gradient */}
            <div className='z-[-1] absolute bottom-0 left-0 w-full h-40 pointer-events-none bg-gradient-to-t from-genius-indigo to-transparent' />

            <LogoutBtn data-sentry-element="LogoutBtn" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </FullScreenGuard>
    </div>;
}